import styled from 'styled-components';

export const FormContent = styled.div`
  position: relative;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  z-index: 2;
  overflow: hidden;

  .forget-password-wrap {
    width: 100%;
    text-align: right;
  }

  .forget-password {
    flex-shrink: 0;
    color: var(--turquoise);
    border: none;
    margin: 10px 0;
    margin-left: auto;
    text-align: right;
    font-weight: 500;
  }

  h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: var(--text-color);
    text-transform: none;

    @media (min-width: 768px) {
      font-size: 30px;
      line-height: 34px;
    }
  }
  .text-content {
    text-align: center;
  }

  .otp-wrapper {
    margin-bottom: 30px;
  }
  .image-wrap-mail {
    max-width: 150px;
    width: 100%;
    margin: 38px auto;
  }
  .text-wrapper {
    width: 100%;
  }
  .heading-text {
    margin-bottom: 30px;

    p {
      i {
        font-weight: 700;
        color: var(--primary);
      }
    }
  }
  .formWrapper {
    button {
      margin-bottom: 15px;
    }
  }
  .text-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    line-height: 17px;
    margin: 0 0 20px;
  }

  .privacy {
    text-align: left;
    max-width: 200px;
    font-size: 13px;
    line-height: 17px;
    color: var(--text-color-50);

    @media (min-width: 768px) {
      max-width: 225px;
    }

    p {
      .color {
        color: #8b91b9;
      }
    }
  }

  .footer {
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    padding: 15px 20px;
    color: var(--text-color);
    a {
      color: var(--text-color);
      font-weight: 700;
    }
  }
`;

export const SuccessContent = styled.div`
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  text-align: center;

  .img-box {
    width: 216px;
    margin: 0 auto 35px;

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .title {
    display: block;
    font-size: 25px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 30px;
    color: var(--primary);
  }
`;
